export default {
  supplementsApi: 'onDemandSupplements.v1',
};
